export const RADIUS = {
	none: '0',
	xs:   '2px',    // subtle rounding
	sm:   '4px',    // badges, pills, small buttons
	md:   '6px',    // buttons, inputs
	lg:   '8px',    // cards, modals, dropdowns
	xl:   '12px',   // large cards
	full: '9999px', // fully rounded — tags, avatars
}
